import { ApiClient } from '@webapp/core/services/ApiClient'
import { TravelRepository } from './TravelRepository'

export const travelRepository = new TravelRepository({
  httpClient: ApiClient,
})

export { TravelRepository }
